export const FETCH_MODELS_PROFILES = 'FETCH_MODELS_PROFILES';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const ADD_MODELS_PROFILES = 'ADD_MODELS_PROFILES';
export const EDIT_MODELS_PROFILES = 'EDIT_MODELS_PROFILES';
export const DELETE_MODELS_PROFILES = 'DELETE_MODELS_PROFILES';
